import React, { useState } from "react";

interface LC {
  layers: { id: string; name: string; opacity: number }[];
  activeLayer?: string | null;
  activeLayers?: string[];
  toggleLayerVisibility: (id: string) => void;
  handleOpacityChange: (id: string, opacity: number) => void;
  mapStyle?: string;
  setMapStyle?: (style: string) => void;
}
const LayerControl: React.FC<LC> = ({
  layers,
  activeLayer,
  activeLayers,
  toggleLayerVisibility,
  handleOpacityChange,
  mapStyle,
  setMapStyle,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleMenu = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className={`layer-controls ${!isExpanded ? 'collapsed' : ''}`}>
      <div className="menu-header" onClick={toggleMenu} style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h4 style={{ margin: 0 }}>{isExpanded ? 'Map Layers' : 'Layers'}</h4>
        <div style={{ color: "#6b7280", fontSize: "18px", fontWeight: "300" }}>
          {isExpanded ? "−" : "+"}
        </div>
      </div>

      {isExpanded && (
        <div className="menu-content">
          {/* Map Style Selector */}
          {setMapStyle && (
            <div className="style-selector" style={{ marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #f3f4f6' }}>
              <h5>Map View</h5>
              <div style={{ display: 'flex', gap: '6px' }}>
                {['satellite', 'outdoors', 'normal'].map((style) => (
                  <button
                    key={style}
                    onClick={() => setMapStyle(style)}
                    className={mapStyle === style ? 'active' : ''}
                    style={{
                      flex: 1,
                      padding: '6px 4px',
                      fontSize: '11px',
                      borderRadius: '6px',
                      backgroundColor: mapStyle === style ? '#22c55e' : '#fff',
                      color: mapStyle === style ? '#fff' : '#4b5563',
                      cursor: 'pointer',
                      textTransform: 'capitalize'
                    }}
                  >
                    {style}
                  </button>
                ))}
              </div>
            </div>
          )}

          <h5>Layers & Opacity</h5>
          {layers.map((layer) => (
            <div key={layer.id} className="layer-item">
              <div className="layer-header" onClick={() => toggleLayerVisibility(layer.id)}>
                <input
                  type="checkbox"
                  id={`layer-${layer.id}`}
                  checked={
                    activeLayers
                      ? activeLayers.includes(layer.id)
                      : activeLayer === layer.id
                  }
                  onChange={(e) => {
                    e.stopPropagation();
                    toggleLayerVisibility(layer.id);
                  }}
                />
                <label htmlFor={`layer-${layer.id}`} onClick={(e) => e.stopPropagation()}>
                  {layer.name}
                </label>
              </div>
              <div>
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.01"
                  value={layer.opacity}
                  onChange={(e) =>
                    handleOpacityChange(layer.id, parseFloat(e.target.value))
                  }
                  title={`Opacity: ${Math.round(layer.opacity * 100)}%`}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayerControl;

